import React from 'react'
import {ReactTinyLink} from 'react-tiny-link'
export default function FileLink(props) {
    let {url}=props
    return (
        <ReactTinyLink
            cardSize="large"
            showGraphic={true}
            maxLine={2}
            minLine={1}
            proxyUrl="https://cors.bridged.cc"
            // proxyUrl=""
            url={url}
        />
    )
}
